import { setup, show } from 'klaro';
import { klaroConfig } from '../config/klaro-config';

let initialized = false;

/** Initialize Klaro CMP. Must run in the browser before GTM loads. */
export function initializeCookieConsent(): void {
  if (typeof window === 'undefined' || initialized) return;
  initialized = true;
  setup(klaroConfig);
}

/** Re-open the Klaro consent modal so users can change or withdraw consent. */
export function showCookiePreferences(): void {
  if (typeof window === 'undefined') return;
  if (!initialized) {
    initializeCookieConsent();
  }
  show(klaroConfig, true);
}
